// Libs
import React from 'react';
import styled, { css, useTheme } from 'styled-components';
// Components
import IconButton from '@mui/material/IconButton';
import Icon from './Icon';

const Button = styled(IconButton)`
	${props =>
		props.shadow &&
		css`
			-webkit-box-shadow:
				-10px 0px 13px -7px #000000,
				10px 0px 13px -7px #000000,
				5px 5px 15px 5px rgba(0, 0, 0, 0);
			box-shadow:
				-10px 0px 13px -7px #000000,
				10px 0px 13px -7px #000000,
				5px 5px 15px 5px rgba(0, 0, 0, 0);
		`}
`;

const RenderIcon = ({ onClick }) => {
	const theme = useTheme();
	return <Icon fill={theme.colors.text.high} onClick={onClick} />;
};

const DragIcon = ({ button, onClick, shadow }) => {
	if (button) {
		return (
			<Button shadow={shadow} onClick={onClick}>
				<RenderIcon />
			</Button>
		);
	}

	return <RenderIcon onClick={onClick} />;
};

export default DragIcon;
